var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M16 3.538a6.545 6.545 0 0 1-1.885.516 3.286 3.286 0 0 0 1.442-1.816 6.574 6.574 0 0 1-2.084.797 3.279 3.279 0 0 0-2.396-1.037c-2.119 0-3.676 1.977-3.198 4.03a9.32 9.32 0 0 1-6.765-3.43A3.287 3.287 0 0 0 2.13 6.981a3.258 3.258 0 0 1-1.486-.41C.607 8.092 1.698 9.514 3.276 9.83a3.291 3.291 0 0 1-1.483.057 3.285 3.285 0 0 0 3.067 2.279A6.602 6.602 0 0 1 0 13.526 9.288 9.288 0 0 0 5.032 15c6.094 0 9.539-5.146 9.33-9.763A6.681 6.681 0 0 0 16 3.538z" })
  );
});


// WEBPACK FOOTER //
// ./src/media/icon-twitter.svg